import { Spinner } from "react-bootstrap";

export default function Loading(props){
 return(<>
 <Spinner size="lg" variant="info" />
 </>) 
 
}